angular
  .module("meanApp")
  .controller("property-portfolio-controller", function(
    $scope,
    $stateParams,
    Auth,
    $rootScope,
  ) {
    "use strict";

    // check if user is admin
    $scope.isAdmin = false;
    Auth.isAdmin().then(isAdmin => ($scope.isAdmin = isAdmin));
    // get user ID from parent scope which is in the dashboard
    $scope.userID = $rootScope.loggedUserId || $stateParams.clientId;

    const reactContainerNode = document.getElementById("react-wrapper-portfolio-plan");
    ReactDOM.unmountComponentAtNode(reactContainerNode);
    ReactDOM.render(
      React.createElement(PropertyPortfolio.default, {
        clientUID: $scope.isAdmin ? $stateParams.clientId : $scope.userID
      }),
      reactContainerNode
    );
    $scope.$on("$destroy", () => {
      ReactDOM.unmountComponentAtNode(reactContainerNode);
    });
  });
